import React from 'react';
import './TopBarButton.css';

const TopBarButton = ({ icon, label, onClick, active, badge }) => (
  <button
    className={`topbar-button${active ? ' active' : ''}`}
    onClick={onClick}
    type="button"
    aria-label={label}
  >
    <span className="topbar-icon">{icon}</span>
    {badge > 0 && (
      <span className="topbar-badge">{badge > 9 ? '9+' : badge}</span>
    )}
    <span className="topbar-label">{label}</span>
  </button>
);

export default TopBarButton;
